/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
import React from 'react';
import { Typography } from '@material-ui/core';
import CustomToolbar from '../../common/CustomToolbar/CustomToolbar';

import _ from '../../../utils/lodash';

const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = [
    'Name',
    'NumberOfClinicians',
    'Duration',
    'TimeAverage',
    'ActivityType',
    'RagStatusName',
    'BandId',
  ];
  const dtoNames = [
    'description',
    'requiredClinicians',
    'duration',
    'timeAverage',
    'activityTypeName',
    'ragName',
    'bandName',
  ];
  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }
  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

const mapRowData = (rowData, eventHandlers) => {
  const mappedRowData = [
    'id',
    'description',
    'activityTypeId',
    'activityTypeName',
    'ragId',
    'ragName',
    'requiredClinicians',
    'duration',
    'timeAverage',
    'bandId',
    'bandName',
    'skillIds',
    'varianceFactors',
    'status',
    'isAssigned',
    'externalCode',
    'orgUnitIds',
  ];
  const result = {};
  // eslint-disable-next-line no-return-assign
  mappedRowData.forEach((data, i) => {
    if (data === 'status') {
      result[data] = rowData[i] === 'Active'; // map 'status' value from string to boolean for the sidepanel toogle and save
    } else {
      result[data] = rowData[i];
    }
  });
  eventHandlers.handleSidePanel(true, result);
};

export const tableSettings = options => {
  const locale = options.eventHandlers.locale;
  const eventHandlers = options.eventHandlers;

  return {
    name: <Typography variant="h3">Activities</Typography>,
    columns: [
      {
        name: 'id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'description',
        label: locale.getMsg('description'),
        options: {
          sortOrder: {
            name: 'description',
            direction: setSortDirection('description', options),
          },
          setCellProps: () => ({ style: { maxWidth: '300px' } }),
        },
      },
      {
        name: 'activityTypeId',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'activityTypeName',
        label: locale.getMsg('activityTypeName'),
        options: {
          sort: true,
          sortOrder: {
            name: 'activityTypeName',
            direction: setSortDirection('activityTypeName', options),
          },
          setCellProps: () => ({ style: { maxWidth: '200px' } }),
        },
      },
      {
        name: 'ragId',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'ragName',
        label: locale.getMsg('ragName'),
        options: {
          sort: true,
          sortOrder: {
            name: 'ragName',
            direction: setSortDirection('ragName', options),
          },
          setCellProps: () => ({ style: { maxWidth: '150px' } }),
        },
      },
      {
        name: 'requiredClinicians',
        label: locale.getMsg('requiredClinicians'),
        options: {
          sortOrder: {
            name: 'requiredClinicians',
            direction: setSortDirection('requiredClinicians', options),
          },
          setCellProps: () => ({ style: { maxWidth: '50px' } }),
        },
      },
      {
        name: 'duration',
        label: locale.getMsg('duration'),
        options: {
          sortOrder: {
            name: 'duration',
            direction: setSortDirection('duration', options),
          },
          setCellProps: () => ({ style: { maxWidth: '90px' } }),
        },
      },
      {
        name: 'timeAverage',
        label: locale.getMsg('timeAverage'),
        options: {
          sortOrder: {
            name: 'timeAverage',
            direction: setSortDirection('timeAverage', options),
          },
          setCellProps: () => ({ style: { maxWidth: '90px' } }),
        },
      },
      {
        name: 'bandId',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'bandName',
        label: locale.getMsg('equivalence'),
        options: {
          sort: true,
          sortOrder: {
            name: 'bandName',
            direction: setSortDirection('bandName', options),
          },
          setCellProps: () => ({ style: { maxWidth: '100px' } }),
        },
      },
      {
        name: 'skillIds',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'varianceFactors',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'status',
        label: locale.getMsg('status'),
        options: {
          sort: false,
          customBodyRender: value => {
            return value === true ? 'Active' : 'Inactive';
          },
          setCellProps: () => ({ style: { maxWidth: '50px' } }),
        },
      },
      {
        name: 'isAssigned',
        label: locale.getMsg('isAssigned'),
        options: {
          sort: false,
          customBodyRender: value => {
            return value === true ? 'Yes' : 'No';
          },
          setCellProps: () => ({ style: { maxWidth: '50px' } }),
        },
      },
      {
        name: 'externalCode',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'orgUnitIds',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'orgUnitsNames',
        label: locale.getMsg('mappedToTeams'),
        options: {
          sort: false,
          display: options.enableMappingOfActivities,
          setCellProps: () => ({ style: { maxWidth: '400px' } }),
        },
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 15, 30, 50, 100],
      rowsPerPage: options.pageSize,
      print: true,
      search: false,
      filter: false,
      serverSide: true,
      count: options.count,
      page: options.page,
      customToolbar: () => (
        <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isTableDataLoading} />
      ),
      onRowClick: rowData => mapRowData(rowData, eventHandlers),
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
          case 'changeRowsPerPage':
            options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
            break;
          case 'sort':
            let sortColumn = '';
            let sortDirection = '';

            if (tableState.activeColumn > -1) {
              sortColumn = mapPropName(tableState.sortOrder.name);
              sortDirection = tableState.sortOrder.direction;
              options.eventHandlers.updateTableSort(sortColumn, sortDirection);
            }
            break;
        }
      },
    },
  };
};
